import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import CommentAction from "./CommentAction";
import CommentInteraction from "./CommentInteraction";
import CommentReplyInteraction from "./CommentReplyInteraction";
import CommentReplyAction from "./CommentReplyAction";
import EditComment from "./EditComment";
import axios from "../../API/axios";
import SingleCommentInteraction from "./SingleCommentInteraction";
import SingleCommentReplyInteraction from "./SingleCommentReplyInteraction";
import SingleCommentAction from "./SingleCommentAction";
import CommentReplyActionSingle from "./CommentReplyActionSingle";
import { post } from "../../config/imagesLink";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";
import "moment/locale/ar";
import "moment/locale/hi";
import "moment/locale/en-gb";

const SingleComment = ({
  AllPostComments,
  isOwnedPost,
  singlepostCommentList,
  postId,
  updateCommentCount,
  AllPostList,
  setSinglePostListInfo,
  singlepostListinfo,
  singlepostList,
  setSinglePostList,
  emojiList,
  setPostList,
  setSinglePostCommentList,
  postList,
  updateLikeCount,
  updateCommentLike,
  updateReplyCommentLike,
}) => {
  const sessionId = localStorage.getItem("sessionId");
  // console.log("singlepostList222222222", postId);
  // console.log("singleCommentPost===>", singlepostListinfo);
  const { t } = useTranslation();

 const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
   const language = localStorage.getItem("Lang");
 const localeMap = {
      en: "en",
      ar: "ar",
      hi: "hi",
    };

const locale = localeMap[language] || "en";
  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);


  // State for tracking which comment is being edited
  const [editedDynamicValue, setEditedDynamicValue] = useState([])
  const [editingCommentId, setEditingCommentId] = useState(null);
  const [editingReplyId, setEditingReplyId] = useState(null); // State for reply editing
  const [commentsState, setCommentsState] = useState([]);
  const [postID, setpostId] = useState(postId);

  console.log("singlepostCommentList", singlepostCommentList);

  // useEffect: initialize commentsState from singlepostCommentList
  useEffect(() => {
    if (singlepostCommentList && Array.isArray(singlepostCommentList)) {
      setCommentsState(
        singlepostCommentList.map((comment) => ({
          ...comment,
          editedComment: comment.comment ?? "", // editable copy
          commentsReplies: comment.commentsReplies?.map((reply) => ({
            ...reply,
            editedReply: reply.reply ?? "",
          })) ?? [],
        }))
      );
    } else {
      setCommentsState([]);
    }
  }, [singlepostCommentList]); // IMPORTANT: depend on comment list (not postInfo)


  console.log("singlepostList", singlepostList);

  // Unified updateComment: updates local UI state, modal comment list and global newsfeed postList
  const updateComment = (pstCmntId, newComment) => {
    // 1) update commentsState used by this component
    setCommentsState((prev) =>
      prev.map((comment) =>
        comment.pstCmntId === pstCmntId
          ? { ...comment, comment: newComment, editedComment: newComment }
          : comment
      )
    );

    // 2) update single post's comment list (modal / single post view)
    if (typeof setSinglePostCommentList === "function") {
      setSinglePostCommentList((prev = []) =>
        prev.map((comment) =>
          comment.pstCmntId === pstCmntId ? { ...comment, comment: newComment } : comment
        )
      );
    }

    // 3) update global newsfeed post list so changes reflect immediately in feed
    if (typeof setPostList === "function") {
      setPostList((prevList = []) =>
        prevList.map((postWrapper) => {
          if (postWrapper?.postInfo?.postId !== postId) return postWrapper;
          return {
            ...postWrapper,
            postInfo: {
              ...postWrapper.postInfo,
              comments: (postWrapper.postInfo.comments || []).map((c) =>
                c.pstCmntId === pstCmntId ? { ...c, comment: newComment } : c
              ),
            },
          };
        })
      );
    }
  };


  const handleEdit = (commentId) => {
    setEditingCommentId(commentId); // Set the comment to be edited
  };

 const filterArrayByString = (inputString, dataArray) => {
    
    const allowedDVnos = Array.from(
      inputString.matchAll(/\{(\d+)\}/g),
      (match) => Number(match[1])
    );
  
    return dataArray.filter((item) => allowedDVnos.includes(item.dVno));
  };

  const handleSave = async (commentId) => {
    const commentToEdit = commentsState.find(
      (comment) => comment.pstCmntId === commentId
    );

 const filterEditedDynamicValue = filterArrayByString(
      commentToEdit.editedComment,
      editedDynamicValue
    );

    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      pstCmntId: commentId,
      comment: commentToEdit.editedComment, // Use the updated comment
      // dynamicValues: editedDynamicValue
      dynamicValues: filterEditedDynamicValue,
            langKey: language === "en" ? "" : language,

    };

    try {
      const response = await axios.post(`PostAction/UpdateCommentPost`, responseData);
      //updateComment(commentId, commentToEdit.editedComment);
      // AllPostList()
      // AllPostComments()
      // Update comment in UI
      if(response.data.status === "Success"){
        setShowToast(true)
        setToastMessage(response.data.message)
      }

      updateComment(commentId, commentToEdit.editedComment);
      setEditingCommentId(null); // Exit edit mode
       AllPostList();
    } catch (error) {
      console.error("Error saving comment:", error);
    }
  };

  const handleCommentChange = (commentId, newComment) => {
    if (newComment !== "") {
      setCommentsState(
        commentsState.map((comment) =>
          comment.pstCmntId === commentId
            ? 
            { ...comment,
               editedComment: newComment,
               dynamicValues: editedDynamicValue,
               }
            : comment
        )
      );
    }
  };

  const updateReply = (commentId, replyId, newReply) => {
    // 1) update commentsState used by this component
    setCommentsState((prev) =>
      prev.map((comment) =>
        comment.pstCmntId === commentId
          ? {
            ...comment,
            commentsReplies: (comment.commentsReplies || []).map((r) =>
              r.pstCmntRplyId === replyId ? { ...r, reply: newReply, editedReply: newReply } : r
            ),
          }
          : comment
      )
    );

    // 2) update modal/single-post comment list
    if (typeof setSinglePostCommentList === "function") {
      setSinglePostCommentList((prev = []) =>
        prev.map((comment) =>
          comment.pstCmntId === commentId
            ? {
              ...comment,
              commentsReplies: (comment.commentsReplies || []).map((r) =>
                r.pstCmntRplyId === replyId ? { ...r, reply: newReply } : r
              ),
            }
            : comment
        )
      );
    }

    // 3) update global single-post list so feed reflects change immediately
    if (typeof setPostList === "function") {
      setPostList((prevList = []) =>
        prevList.map((postWrapper) =>
          postWrapper?.postInfo?.postId === postId
            ? {
              ...postWrapper,
              postInfo: {
                ...postWrapper.postInfo,
                comments: (postWrapper.postInfo.comments || []).map((c) =>
                  c.pstCmntId === commentId
                    ? {
                      ...c,
                      commentsReplies: (c.commentsReplies || []).map((r) =>
                        r.pstCmntRplyId === replyId ? { ...r, reply: newReply } : r
                      ),
                    }
                    : c
                ),
              },
            }
            : postWrapper
        )
      );
    }
  };


  const handleReplyEdit = (replyId) => {
    setEditingReplyId(replyId);
  };

  const handleReplySave = async (commentId, replyId) => {
    const commentToEdit = commentsState.find(
      (comment) => comment.pstCmntId === commentId
    );
    const replyToEdit = commentToEdit.commentsReplies.find(
      (reply) => reply.pstCmntRplyId === replyId
    );

    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      pstCmntRplyId: replyId,
      reply: replyToEdit.editedReply, // Use the updated reply
            langKey: language === "en" ? "" : language,

    };

    try {
      const response = await axios.post(`PostAction/UpdateCommentReply`, responseData);
      if(response.data.status==="Success"){
        setShowToast(true)
        setToastMessage(response.data.message)
      } 
      updateReply(commentId, replyId, replyToEdit.editedReply);
      setEditingReplyId(null); // Exit reply edit mode
    } catch (error) {
      console.error("Error saving reply:", error);
    }
  };

  const handleReplyChange = (commentId, replyId, newReply) => {
    setCommentsState(
      commentsState.map((comment) =>
        comment.pstCmntId === commentId
          ? {
            ...comment,
            commentsReplies: comment.commentsReplies.map((reply) =>
              reply.pstCmntRplyId === replyId
                ? { ...reply, editedReply: newReply }
                : reply
            ),
          }
          : comment
      )
    );
  };

  const addTargetBlankToAnchors = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;

    const anchors = div.querySelectorAll("a");
    anchors.forEach((anchor) => {
      anchor.setAttribute("target", "_blank");
      anchor.setAttribute("rel", "noopener noreferrer");
    });

    return div.innerHTML;
  };

  const linkifyContent = (htmlContent) => {
    const urlPattern =
      /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
    return htmlContent.replace(urlPattern, function (url) {
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });
  };

//   const linkifyContent = (text, dynamicValues = []) => {
//   if (!text) return "";

//   // 1. Replace URLs
//   const urlPattern =
//     /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
//   text = text.replace(
//     urlPattern,
//     (url) =>
//       `<a href="${url}" target="_blank" rel="noopener noreferrer" class="url-link">${url}</a>`
//   );

//   // 2. Replace @mentions (with userId from dynamicValues)
//   text = text.replace(/@([a-zA-Z0-9_]+)/g, (match, value) => {
//     const user = dynamicValues.find(
//       (dv) => dv.type === "mention" && dv.value === value
//     );
//     if (user) {
//       return `<a href="/profile/${user.userId}" class="mention-link">@${value}</a>`;
//     }
//     return match;
//   });

//   // 3. Replace #hashtags
//   text = text.replace(/#(\w+)/g, (match, tag) => {
//     return `<a href="/hashtag/${tag}" class="hashtag-link">#${tag}</a>`;
//   });

//   return text;
// };

  // console.log("singlepostList..........", singlepostList);

  const replaceDynamicValues = (content, dynamicValues) => {
    if (!content || !dynamicValues) return content;

    
    dynamicValues.forEach((item) => {
      const placeholder = `{${item.dVno}}`;
      const cleanDisplay = stripLeadingHashes(item.displayName || item.display);

      const replacement =
        item.type === "UserMention"
          ? `<a href="/user/${item.entityID || item?.entity}" class="user-mention">@${item.displayName || item?.display}</a>`
       : item.type === "CompanyMention"
          ? `<a href="/Company/${item.entityID || item?.entity}" class="user-mention">@${item.displayName || item?.display}</a>`
          : item.type === "Hashtag"
            ? `<a href="/hashtag/${cleanDisplay}" class="hashtag">#${item.displayName || item?.display}</a>`
            : item.displayName;

      content = content.replaceAll(placeholder, replacement);
    });

    return content;
  };

    const stripLeadingHashes = (str) => {
    return str.replace(/^#+/, "");
  };

const parseMentionsAndHashtags = (text) => {
  if (!text) return "";

  let parsedText = text.replace(
    /(^|\s)@(\w+)/g,
    '$1<a href="/profile/$2" class="mention-link">@$2</a>'
  );

  parsedText = parsedText.replace(
    /(^|\s)#(\w+)/g,
    '$1<a href="/hashtag/$2" class="hashtag-link">#$2</a>'
  );

  return parsedText;
};

    const commentedPost = (item) => {
  const withDynamicValues = replaceDynamicValues(
    item?.editedComment,
    item?.dynamicValues
  );

  const withMentionsAndTags = parseMentionsAndHashtags(withDynamicValues);

  const withAnchors = addTargetBlankToAnchors(withMentionsAndTags);

  const formattedContent = linkifyContent(withAnchors);

  return formattedContent;
};
  // const commentedPost = (item) => {
  //   const formattedContent = linkifyContent(
  //     addTargetBlankToAnchors(
  //       replaceDynamicValues(
  //         item?.editedComment,
  //         item?.dynamicValues
  //       )
  //     )
  //   );
  //   return formattedContent;
  // }

  console.log("commentsState", commentsState)

  const [expandedReplies, setExpandedReplies] = useState({});

  const toggleReplies = (commentId) => {
    setExpandedReplies((prev) => ({
      ...prev,
      [commentId]: !prev[commentId],
    }));
  };


  return (
    <>
      <div className="comment-section mt-1">
        {commentsState && commentsState.length > 0 ? (
          commentsState.map((commentItem, index) => {
            // console.log("commentItemcommentItem", commentItem.creationTime);
                     const now = moment.utc().local();
                     const itemTime = moment.utc(commentItem?.creationTime).local();
 
                     const diffSeconds = now.diff(itemTime, "seconds");
                     const diffMinutes = now.diff(itemTime, "minutes");
                     const diffHours = now.diff(itemTime, "hours");
                     const diffDays = now.diff(itemTime, "days");
 
                     const diffMonths = now.diff(itemTime, "months", true);
                     const diffYears = now.diff(itemTime, "years", true);
 
                     let result = "";
 
                     /* JUST NOW */
                     if (diffSeconds < 60) {
                       result = t("Notifications.Just Now");
                     }
 
                     /* MINUTES */
                     else if (diffMinutes < 60) {
                       result =
                         diffMinutes === 1
                           ? `${diffMinutes} ${t("Notifications.Minute")} ${t("Notifications.Ago")}`
                           : `${diffMinutes} ${t("Notifications.Minutes")} ${t("Notifications.Ago")}`;
                     }
 
                     /* HOURS */
                     else if (diffHours < 24) {
                       result =
                         diffHours === 1
                           ? `${diffHours} ${t("Notifications.Hour")} ${t("Notifications.Ago")}`
                           : `${diffHours} ${t("Notifications.Hours")} ${t("Notifications.Ago")}`;
                     }
 
                     /* DAYS */
                     else if (diffDays < 30) {
                       result =
                         diffDays === 1
                           ? `${diffDays} ${t("Notifications.Day")} ${t("Notifications.Ago")}`
                           : `${diffDays} ${t("Notifications.Days")} ${t("Notifications.Ago")}`;
                     }
 
                     /* MONTHS */
                     else if (diffMonths < 12) {
                       const displayMonth =
                         diffMonths >= 0.75 && diffMonths < 1.25
                           ? 1
                           : Math.round(diffMonths * 2) / 2;
 
                       result =
                         displayMonth === 1
                           ? `${displayMonth} ${t("Notifications.Month")} ${t("Notifications.Ago")}`
                           : `${displayMonth} ${t("Notifications.Months")} ${t("Notifications.Ago")}`;
                     }
 
                     /* YEARS */
                     else {
                       const displayYear =
                         diffYears >= 0.75 && diffYears < 1.25
                           ? 1
                           : Math.round(diffYears * 2) / 2;
 
                       result =
                         displayYear === 1
                           ? `${displayYear} ${t("Notifications.Year")} ${t("Notifications.Ago")}`
                           : `${displayYear} ${t("Notifications.Years")} ${t("Notifications.Ago")}`;
                     }
             return(
           
            <div key={index} className=" rounded pe-1"
              style={{
                border: "1px solid #dcdcdc",
                width: "100%",
                marginBottom: '5px'

              }}>
              <div className="mainComment d-flex mb-1 p-1  d-flex">
                <Link to={`/User/${commentItem.useruid}`}>
                  <div>
                    <img
                      src={commentItem?.userAvatar}
                      width={30}
                      height={30}
                      alt=""
                      style={{
                        borderRadius: "50px",
                        border: "1px solid black",
                      }}
                    />
                  </div>
                </Link>


                <div className="w-100">
                  <div className="userCommentdetail ms-2">
                    <div className="d-flex align-items-center justify-content-between">
                      <h4 className="f-12 fw-bold mb-0">
                        {commentItem?.userName}
                      </h4>
                      <div className="d-flex align-items-center gap-2"> 
                             {/* <Tooltip title={moment
                               .utc(commentItem?.creationTime)
                                 .local().format("DD MMMM YYYY [at] h:mm a")} arrow>
                             <span  className="f-7" style={{ fontSize: "10px" }}  >
                              {result} 
                                 </span>
                                          </Tooltip>   */}
                                           {language === "ar" ? (
                                             <Tooltip title={moment
                                                    .utc(commentItem.creationTime)
                                                    .locale(locale)
                                                    .local()
                                                    .format( "D MMMM YYYY [الساعة] h:mm a" )} arrow>
                                                <p className="f-10 label"> 
                                                  {moment
                                                    .utc(commentItem.creationTime)
                                                    .locale(locale)
                                                    .local()
                                                    .format("D MMMM YYYY [الساعة] h:mm a" )}
                                                </p>
                                             </Tooltip>
                                                 
                                          ) : (
                                               <Tooltip title={moment
                                                    .utc(commentItem.creationTime)
                                                    .local()
                                                    .format(language === "en"
                                                        ? "D MMMM YYYY [at] h:mm a"
                                                        :  "D MMMM YYYY [को] h:mm a" )} arrow>
                                                <p className="f-10 label"> 
                                                  {result}
                                                  {/* {moment(item?.postInfo?.creationTime).fromNow()}  */}
                                                </p>
                                             </Tooltip> 
  
                                          )}            
                        <SingleCommentInteraction
                          isOwnedPost={isOwnedPost}
                          updateCommentCount={updateCommentCount}
                          singlepostListinfo={singlepostListinfo}
                          setSinglePostListInfo={setSinglePostListInfo}
                          item={commentItem}
                          handleSave={() => handleSave(commentItem.pstCmntId)}
                          handleEdit={() => handleEdit(commentItem.pstCmntId)}
                          isEditing={editingCommentId === commentItem.pstCmntId}
                          setSinglePostCommentList={setSinglePostCommentList}
                          singlepostCommentList={singlepostCommentList}
                          postList={postList}
                          setPostList={setPostList}
                          singlepostList={singlepostList}
                          setSinglePostList={setSinglePostList}
                          postId={postId}
                          AllPostComments={AllPostComments}
                        />
                      </div>
                    </div>
               
                    <div className="commentText">
                      {editingCommentId === commentItem.pstCmntId ? (
                        <div style={{ width: "100%" }}> {/* Ensure consistent width */}
                          <EditComment
                            isEditing={true}
                            editedComment={commentItem.editedComment}
                            handleCommentChange={(newComment) =>
                              handleCommentChange(commentItem.pstCmntId, newComment)
                            }
                            handleSave={() => handleSave(commentItem.pstCmntId)}
                            setIsEditing={() => setEditingCommentId(null)}
                            dynamicValues={commentItem?.dynamicValues}
                            setEditedDynamicValue={setEditedDynamicValue}
                          />
                        </div>
                      ) : (
                        <div
                          className='postContentDiv'
                          dangerouslySetInnerHTML={{
                            __html: commentedPost(commentItem),
                          }}
                        />
                      )}
                    </div>

                  </div>
                  <SingleCommentAction
                    item={commentItem}
                    postList={singlepostList}
                    setPostList={setPostList}
                    AllPostList={AllPostList}
                    emojiList={emojiList}
                    setSinglePostCommentList={setSinglePostCommentList}
                    singlepostCommentList={singlepostCommentList}
                    singlepostList={singlepostList}
                    setSinglePostList={setSinglePostList}
                    postId={postId}
                    singlepostListinfo={singlepostListinfo}
                    setSinglePostListInfo={setSinglePostListInfo}
                    updateCommentLike={updateCommentLike}
                    updateLikeCount={updateLikeCount}
                  />
                </div>
              </div>

              {/* Comment Replies */}
              {commentItem?.commentsReplies?.length > 0 && (
                <>
                  {/* Show only first reply */}
                  <div
                    className="mainComment d-flex mb-1 ms-5 rounded d-flex p-1"
                    style={{
                      border: "1px solid #dcdcdc",
                      // maxWidth: "800px",
                    }}
                    key={0}
                  >
                    <div className="mt-1 ms-1">
                      <img
                        src={commentItem.commentsReplies[0]?.userAvatar}
                        width={30}
                        height={30}
                        alt=""
                        style={{
                          borderRadius: "50px",
                          border: "1px solid black",
                        }}
                      />
                    </div>
                    <div className="w-100 mt-1">
                      <div className="userCommentdetail ms-2">
                        <div className="d-flex align-items-center justify-content-between">
                          <h4 className="f-12 fw-bold mb-0">
                            {commentItem.commentsReplies[0]?.userName}
                          </h4>
                          <div className="d-flex align-items-center gap-2">
                            {/* <span className="f-7 " style={{ fontSize: '10px' }}>
                              {moment
                                .utc(commentItem?.commentsReplies?.creationTime)
                                .local()
                                .format("DD MMM YYYY, h:mm a")}
                            </span> */}
                             {/* <Tooltip title={moment
                                                    .utc(commentItem?.commentsReplies?.creationTime)
                                                    .local()
                                                    .format("DD MMMM YYYY [at] h:mm a")} arrow>
                                               <span
                                                  className="f-7  comment-dateSection"
                                                  style={{ fontSize: "10px" }}
                                                >
                              {result}
                                               </span>
                                          </Tooltip>   */}
                                            {language === "ar" ? (
                                             <Tooltip title={moment
                                                    .utc(commentItem.commentsReplies.creationTime)
                                                    .locale(locale)
                                                    .local()
                                                    .format( "D MMMM YYYY [الساعة] h:mm a" )} arrow>
                                                <p className="f-10 label"> 
                                                  {moment
                                                    .utc(commentItem.commentsReplies.creationTime)
                                                    .locale(locale)
                                                    .local()
                                                    .format("D MMMM YYYY [الساعة] h:mm a" )}
                                                </p>
                                             </Tooltip>
                                                 
                                          ) : (
                                               <Tooltip title={moment
                                                    .utc(commentItem.creationTime)
                                                    .local()
                                                    .format(language === "en"
                                                        ? "D MMMM YYYY [at] h:mm a"
                                                        :  "D MMMM YYYY [को] h:mm a" )} arrow>
                                                <p className="f-10 label"> 
                                                  {result}
                                                  {/* {moment(item?.postInfo?.creationTime).fromNow()}  */}
                                                </p>
                                             </Tooltip> 
  
                                          )}
                            <SingleCommentReplyInteraction
                              isOwnedPost={isOwnedPost}
                              item={commentItem.commentsReplies[0]}
                              handleReplySave={() =>
                                handleReplySave(
                                  commentItem.pstCmntId,
                                  commentItem.commentsReplies[0].pstCmntRplyId
                                )
                              }
                              handleReplyEdit={() =>
                                handleReplyEdit(commentItem.commentsReplies[0].pstCmntRplyId)
                              }
                              isEditing={
                                editingReplyId ===
                                commentItem.commentsReplies[0].pstCmntRplyId
                              }
                              setPostList={setPostList}
                              postList={postList}
                              postId={postId}
                              setSinglePostList={setSinglePostList}
                              singlepostList={singlepostList}
                              setSinglePostListInfo={setSinglePostListInfo}
                              singlepostListinfo={singlepostListinfo}
                              commentId={commentItem.pstCmntId}
                              setSinglePostCommentList={setSinglePostCommentList}
                              singlepostCommentList={singlepostCommentList}
                              setCommentsState={setCommentsState}
                            />
                          </div>
                        </div>
                        <div className="commentText">
                          {editingReplyId ===
                            commentItem.commentsReplies[0].pstCmntRplyId ? (
                            <EditComment
                              isEditing={true}
                              editedComment={
                                commentItem.commentsReplies[0].editedReply
                              }
                              handleCommentChange={(newReply) =>
                                handleReplyChange(
                                  commentItem.pstCmntId,
                                  commentItem.commentsReplies[0].pstCmntRplyId,
                                  newReply
                                )
                              }
                              handleSave={() =>
                                handleReplySave(
                                  commentItem.pstCmntId,
                                  commentItem.commentsReplies[0].pstCmntRplyId
                                )
                              }
                              setIsEditing={() => setEditingReplyId(null)}
                              dynamicValues={
                                commentItem.commentsReplies[0]?.dynamicValues
                              }
                              setEditedDynamicValue={setEditedDynamicValue}
                            />
                          ) : (
                            <p className="f-12">
                              {commentItem.commentsReplies[0]?.editedReply}
                            </p>
                          )}
                        </div>
                      </div>
                      <CommentReplyActionSingle
                        item={commentItem.commentsReplies[0]}
                        emojiList={emojiList}
                        setPostList={setSinglePostList}
                        postList={postList}
                        postId={postId}
                        singlepostList={singlepostList}
                        setSinglePostList={setSinglePostList}
                        commentId={commentItem.pstCmntId}
                        setSinglePostCommentList={setSinglePostCommentList}
                        singlepostCommentList={singlepostCommentList}
                        updateReplyCommentLike={updateReplyCommentLike}
                        
                      />
                    </div>
                  </div>

                  {/* Toggle Button */}

                  {/* Show remaining replies if expanded */}
                 {expandedReplies[commentItem.pstCmntId] &&
  commentItem.commentsReplies.slice(1).map((reply, replyIndex) => {
    console.log("replyssssssssssssss", reply);
    

    const now = moment.utc().local();
    const itemTime = moment.utc(reply?.creationTime).local();

    const diffSeconds = now.diff(itemTime, "seconds");
    const diffMinutes = now.diff(itemTime, "minutes");
    const diffHours = now.diff(itemTime, "hours");
    const diffDays = now.diff(itemTime, "days");
    const diffMonths = now.diff(itemTime, "months", true);
    const diffYears = now.diff(itemTime, "years", true);

    let result = "";

    /* JUST NOW */
    if (diffSeconds < 60) {
      result = t("Notifications.Just Now");
    }

    /* MINUTES */
    else if (diffMinutes < 60) {
      result =
        diffMinutes === 1
          ? `${diffMinutes} ${t("Notifications.Minute")} ${t("Notifications.Ago")}`
          : `${diffMinutes} ${t("Notifications.Minutes")} ${t("Notifications.Ago")}`;
    }

    /* HOURS */
    else if (diffHours < 24) {
      result =
        diffHours === 1
          ? `${diffHours} ${t("Notifications.Hour")} ${t("Notifications.Ago")}`
          : `${diffHours} ${t("Notifications.Hours")} ${t("Notifications.Ago")}`;
    }

    /* DAYS */
    else if (diffDays < 30) {
      result =
        diffDays === 1
          ? `${diffDays} ${t("Notifications.Day")} ${t("Notifications.Ago")}`
          : `${diffDays} ${t("Notifications.Days")} ${t("Notifications.Ago")}`;
    }

    /* MONTHS */
    else if (diffMonths < 12) {
      const displayMonth =
        diffMonths >= 0.75 && diffMonths < 1.25
          ? 1
          : Math.round(diffMonths * 2) / 2;

      result =
        displayMonth === 1
          ? `${displayMonth} ${t("Notifications.Month")} ${t("Notifications.Ago")}`
          : `${displayMonth} ${t("Notifications.Months")} ${t("Notifications.Ago")}`;
    }

    /* YEARS */
    else {
      const displayYear =
        diffYears >= 0.75 && diffYears < 1.25
          ? 1
          : Math.round(diffYears * 2) / 2;

      result =
        displayYear === 1
          ? `${displayYear} ${t("Notifications.Year")} ${t("Notifications.Ago")}`
          : `${displayYear} ${t("Notifications.Years")} ${t("Notifications.Ago")}`;
    }

    return (
      // <div
      //   className="mainComment d-flex mb-1 ms-5 rounded"
      //   style={{ border: "1px solid #dcdcdc", maxWidth: "800px" }}
      //   key={replyIndex}
      // >
      //   <div className="mt-1 ms-1">
      //     <img
      //       src={reply?.userAvatar}
      //       width={30}
      //       height={30}
      //       alt=""
      //       style={{ borderRadius: "50px", border: "1px solid black" }}
      //     />
      //   </div>

      //   <div className="w-100 mt-1">
      //     <div className="userCommentdetail ms-2">
      //       <div className="d-flex align-items-center justify-content-between">
      //         <h4 className="f-12 fw-bold mb-0">{reply?.userName}</h4>

      //         <Tooltip
      //           title={moment
      //             .utc(reply?.creationTime)
      //             .local()
      //             .format("DD MMMM YYYY [at] h:mm a")}
      //           arrow
      //         >
      //           <span className="f-7 comment-dateSection" style={{ fontSize: "10px" }}>
      //             {result}
      //           </span>
      //         </Tooltip>
      //       </div>

      //       <div className="commentText">
      //         <p className="f-12">{reply.editedReply}</p>
      //       </div>
      //     </div>
      //   </div>
      // </div>
        <>
                        <div
                          className="mainComment d-flex mb-1 ms-5 rounded d-flex p-1"
                          style={{
                            border: "1px solid #dcdcdc",
                            // maxWidth: "800px",
                          }}
                          key={replyIndex + 1}
                        >
                          <div className="mt-1 ms-1">
                            <img
                              src={reply?.userAvatar}
                              width={30}
                              height={30}
                              alt=""
                              style={{
                                borderRadius: "50px",
                                border: "1px solid black",
                              }}
                            />
                          </div>
                          <div className="w-100 mt-1">
                            <div className="userCommentdetail ms-2">
                              <div className="d-flex align-items-center justify-content-between">
                                <h4 className="f-12 fw-bold mb-0">{reply?.userName}</h4>
                                <div className="d-flex align-items-center gap-2">
                                  {/* <span className="f-7 " style={{ fontSize: '10px' }}>
                                    {moment
                                      .utc(commentItem?.commentsReplies?.creationTime)
                                      .local()
                                      .format("DD MMM YYYY, h:mm a")}
                                  </span> */}
                                    {/* <Tooltip title={moment
                                                      .utc(commentItem?.commentsReplies?.creationTime)
                                                      .local()
                                                      .format("DD MMMM YYYY [at] h:mm a")} arrow>
                                                  <span
                                                    className="f-7  comment-dateSection"
                                                    style={{ fontSize: "10px" }}
                                                  >
                                                    {result} 
                                                  </span>
                                            </Tooltip>   */}
                                               {language === "ar" ? (
                                                 <Tooltip title={moment
                                                        .utc(reply.creationTime)
                                                        .locale(locale)
                                                        .local()
                                                        .format( "D MMMM YYYY [الساعة] h:mm a" )} arrow>
                                                    <p className="f-10 label"> 
                                                      {moment
                                                        .utc(reply.creationTime)
                                                        .locale(locale)
                                                        .local()
                                                        .format("D MMMM YYYY [الساعة] h:mm a" )}
                                                    </p>
                                                 </Tooltip>
                                                     
                                              ) : (
                                                   <Tooltip title={moment
                                                        .utc(reply.creationTime)
                                                        .local()
                                                        .format(language === "en"
                                                            ? "D MMMM YYYY [at] h:mm a"
                                                            :  "D MMMM YYYY [को] h:mm a" )} arrow>
                                                    <p className="f-10 label"> 
                                                      {result}
                                                      {/* {moment(item?.postInfo?.creationTime).fromNow()}  */}
                                                    </p>
                                                 </Tooltip> 
      
                                              )}                                                    
                                  <SingleCommentReplyInteraction
                                    isOwnedPost={isOwnedPost}
                                    item={reply}
                                    handleReplySave={() =>
                                      handleReplySave(
                                        commentItem.pstCmntId,
                                        reply.pstCmntRplyId
                                      )
                                    }
                                    handleReplyEdit={() =>
                                      handleReplyEdit(reply.pstCmntRplyId)
                                    }
                                    isEditing={editingReplyId === reply.pstCmntRplyId}
                                    setPostList={setSinglePostList}
                                    postList={singlepostList}
                                    postId={postId}
                                    commentId={commentItem.pstCmntId}
                                  />
                                </div>
                              </div>
                              <div className="commentText">
                                {editingReplyId === reply.pstCmntRplyId ? (
                                  <EditComment
                                    isEditing={true}
                                    editedComment={reply.editedReply}
                                    handleCommentChange={(newReply) =>
                                      handleReplyChange(
                                        commentItem.pstCmntId,
                                        reply.pstCmntRplyId,
                                        newReply
                                      )
                                    }
                                    handleSave={() =>
                                      handleReplySave(
                                        commentItem.pstCmntId,
                                        reply.pstCmntRplyId
                                      )
                                    }
                                    setIsEditing={() => setEditingReplyId(null)}
                                    dynamicValues={reply?.dynamicValues}
                                    setEditedDynamicValue={setEditedDynamicValue}
                                  />
                                ) : (
                                  <p className="f-12">{reply.editedReply}</p>
                                )}
                              </div>
                            </div>
                            <CommentReplyActionSingle
                              item={reply}
                              emojiList={emojiList}
                              setPostList={setSinglePostList}
                              postList={singlepostList}
                              postId={postId}
                              commentId={commentItem.pstCmntId}
                            />
                          </div>
                        </div>
                        </>
    );
  })}

                  {commentItem.commentsReplies.length > 1 && (
                    <div className="ms-5 mb-2">
                      <span
                        style={{
                          cursor: "pointer",
                          color: "#0d6efd",
                          fontSize: "13px",
                        }}
                        onClick={() => toggleReplies(commentItem.pstCmntId)}
                      >
                        {expandedReplies[commentItem.pstCmntId]
                          ? "− Show less"
                          : `+ Show ${commentItem.commentsReplies.length - 1} more`}
                      </span>
                    </div>
                  )}

                </>
              )}

            </div>
          )
          }
        )
        ) : (
          // <p>No comments available</p>
          <>
            <div className="mt-2 text-center">
              <img src={post.errorSmall} alt="404 Not Found" height={150} width={120} />
            </div>
          </>
        )}
      </div>

      <SuccessToast
              show={showToast}
              message={toastMessage}
              onClose={() => setShowToast(false)}
            />
      
            <WarningToast
              show={showWarningToast}
              message={warningToastMessage}
              onClose={() => setShowWarningToast(false)}
            />
      
            <ErrorToast
              show={showErrorToast}
              message={ErrorToastMessage}
              onClose={() => setShowErrorToast(false)}
            />
    </>
  );
};

export default SingleComment;